// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xe32","field":"styles_field__1GnpO","fieldCol":"styles_fieldCol__WFnYq","diffCol":"styles_diffCol__1ZZOg","diff":"styles_diff__wAIvJ"};